export const minOneChar = /^.{1,}$/;
export const minTwoChar = /^.{2,}$/;
export const maxFiftyChars = /^.{0,50}$/;
export const maxOneHundredChars = /^.{0,100}$/;
// The following has been changed into a RegExp() object as opposed to a regex literal as the unicode flag was causing compilation issues with next.js
// eslint-disable-next-line prefer-regex-literals
export const validInternationalName = new RegExp("^[\\p{L}]*((\\s|'|,\\s|-)?[\\p{L}])*[.]?$", 'u');
export const excludeNonAlphanumericPlus = /^[A-Za-z0-9\s_&+'-]+$/;
// Per the W3C HTML5 spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
export const validEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
export const intlNameValidation = [
    { rule: minOneChar, error: 'Minimum 1 character' },
    { rule: validInternationalName, error: 'Enter a valid name' },
    { rule: maxFiftyChars, error: 'Maximum 50 characters' },
];
export const nameValidation = [
    { rule: minTwoChar, error: 'Minimum 2 characters' },
    { rule: validInternationalName, error: 'Enter a valid name' },
    { rule: maxOneHundredChars, error: 'Maximum 100 characters' },
];
